import { render, staticRenderFns } from "./modalUbicacionRegistro.vue?vue&type=template&id=3fa60a71&scoped=true&"
import script from "./modalUbicacionRegistro.vue?vue&type=script&lang=js&"
export * from "./modalUbicacionRegistro.vue?vue&type=script&lang=js&"
import style0 from "./modalUbicacionRegistro.vue?vue&type=style&index=0&id=3fa60a71&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa60a71",
  null
  
)

export default component.exports